import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

class PinnedLayers {
	constructor({ layers }) {
		// keep the layers as an array so we can look up the next sibling by index
		this.layers = Array.from(layers)

		// gsap tweens we create for reveal layers, tracked so we can clean them up
		this.tweens = []
	}

	// if a layer has a nested child called [data-layer-trigger] use that as the
	// trigger, otherwise use the layer itself
	getTrigger(layer) {
		return layer.querySelector('[data-layer-trigger]') || layer
	}

	init() {
		this.layers.forEach((layer, index) => {
			const nextLayer = this.layers[index + 1]

			// a "reveal" layer slides up and off to expose the layer beneath it.
			// it needs a layer below to reveal — otherwise fall back to the default.
			if (layer.dataset.layer === 'reveal' && nextLayer) {
				this.createReveal(layer, nextLayer)
			} else {
				this.createCover(layer)
			}
		})
	}

	// default behavior: pin the layer so following layers scroll over/under it
	createCover(layer) {
		ScrollTrigger.create({
			trigger: this.getTrigger(layer),
			start: 'bottom bottom',
			pinSpacing: false,
			pin: true,
			scrub: true,
		})
	}

	// reveal behavior: hold the underlying layer still (pin it) and slide this
	// layer up and off, uncovering it — a "curtain up"
	createReveal(layer, nextLayer) {
		const tween = gsap.to(layer, {
			yPercent: -100,
			ease: 'none',
			scrollTrigger: {
				trigger: this.getTrigger(layer),
				start: 'bottom bottom',
				end: 'bottom top',
				scrub: true,
				pin: nextLayer,
				pinSpacing: false,
			},
		})

		this.tweens.push(tween)
	}

	destroy() {
		this.tweens.forEach((tween) => {
			if (tween.scrollTrigger) tween.scrollTrigger.kill()
			tween.kill()
		})
		this.tweens = []

		ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
		this.layers = []
	}
}

export default PinnedLayers
